export const data = [
  {
    index: 0,
    question:
      "나의 팔 다리가 구속되어 움직이지 못하는 상황이 나를 더욱 흥분하게 만든다.",
    score: [
      {
        answer: "동의",
        로프버니: 50,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        로프버니: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        로프버니: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        로프버니: -16,
        바닐라: -1,
      },
      {
        answer: "대체적으로 비동의",
        로프버니: -38,
        바닐라: -2,
      },
      {
        answer: "비동의",
        로프버니: -50,
        서브미시브: -1,
        스위치: -1,
        바닐라: -3,
      },
    ],
  },
  {
    index: 1,
    question:
      "나는 상대방이 나를 수치스러운 호칭으로 부르거나, 나를 수치스럽게 만드는 행동에 당하는것을 즐긴다.",
    score: [
      {
        answer: "동의",
        디그레이디: 50,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        디그레이디: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        디그레이디: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        디그레이디: -16,
        바닐라: -1,
      },
      {
        answer: "대체적으로 비동의",
        디그레이디: -38,
        바닐라: -2,
      },
      {
        answer: "비동의",
        디그레이디: -50,
        스위치: -1,
        바닐라: -3,
      },
    ],
  },
  {
    index: 2,
    question:
      "나는 상대방을 때릴 때 흥분되고, 어떤 모양으로 자국이 났는지가 중요하다.",
    score: [
      {
        answer: "동의",
        스팽커: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        스팽커: 38,
        도미넌트: -2,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        스팽커: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        스팽커: -16,
        바닐라: -1,
      },
      {
        answer: "대체적으로 비동의",
        스팽커: -38,
        도미넌트: -1,
        바닐라: -2,
      },
      {
        answer: "비동의",
        스팽커: -50,
        도미넌트: -1,
        바닐라: -3,
      },
    ],
  },
  {
    index: 3,
    question:
      "나는 상대방을 학대하여 상대방이 고통스러워하는 모습을 보면 흥분된다.",
    score: [
      {
        answer: "동의",
        헌터: 3,
        사디스트: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        헌터: 2,
        사디스트: 38,
        도미넌트: 1,
        스위치: 1,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        헌터: 1,
        사디스트: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        헌터: -1,
        바닐라: -1,
        사디스트: -16,
      },
      {
        answer: "대체적으로 비동의",
        헌터: -2,
        사디스트: -38,
        도미넌트: 1,
        스위치: 1,
        바닐라: -2,
      },
      {
        answer: "비동의",
        헌터: -3,
        사디스트: -50,
        도미넌트: 1,
        스위치: -1,
        바닐라: -3,
      },
    ],
  },
  {
    index: 4,
    question:
      "나는 상대방에게 강제로 굴복당하든, 완전히 순종적이든, 결과적으로 상대에게 복종하고 통제되고싶다.",
    score: [
      {
        answer: "동의",
        헌터: 3,
        서브미시브: 50,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        헌터: 2,
        서브미시브: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        헌터: 1,
        서브미시브: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        헌터: -1,
        바닐라: -1,
        서브미시브: -16,
      },
      {
        answer: "대체적으로 비동의",
        헌터: -2,
        서브미시브: -38,
        바닐라: -2,
      },
      {
        answer: "비동의",
        헌터: -3,
        서브미시브: -50,
        도미넌트: -12,
        바닐라: -3,
      },
    ],
  },
  {
    index: 5,
    question: "나는 상대방이 나의 명령과 지시에 복종하는 모습을 보면 흥분한다",
    score: [
      {
        answer: "동의",
        마스터: 7,
        슬레이브: -7,
        헌터: -3,
        프레이: -3,
        브랫테이머: -3,
        브랫: -3,
        오너: 3,
        사디스트: 7,
        디그레이더: 7,
        리거: 7,
        도미넌트: 40,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        마스터: 4,
        슬레이브: -4,
        헌터: -2,
        프레이: -2,
        브랫테이머: -2,
        브랫: -2,
        오너: 2,
        사디스트: 5,
        디그레이더: 4,
        리거: 4,
        도미넌트: 35,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        마스터: 2,
        슬레이브: -2,
        헌터: -1,
        프레이: -1,
        브랫테이머: -1,
        브랫: -1,
        오너: 1,
        사디스트: 3,
        디그레이더: 2,
        리거: 2,
        도미넌트: 18,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        마스터: -2,
        오너: -1,
        사디스트: -3,
        디그레이더: -2,
        리거: -2,
        도미넌트: -18,
        바닐라: 1,
      },
      {
        answer: "대체적으로 비동의",
        마스터: -4,
        오너: -2,
        사디스트: -5,
        디그레이더: -4,
        리거: -4,
        도미넌트: -35,
        바닐라: 2,
      },
      {
        answer: "비동의",
        마스터: -7,
        오너: -3,
        사디스트: -7,
        디그레이더: -7,
        리거: -7,
        도미넌트: -40,
        바닐라: 3,
      },
    ],
  },
  {
    index: 6,
    question:
      "나는 나의 파트너가 어떤날은 나에게 복종하지만, 어떤 날은 나를 제압해줬으면 좋겠다.",
    score: [
      {
        answer: "동의",
        스위치: 50,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        스위치: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        스위치: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        스위치: -16,
        바닐라: -1,
      },
      {
        answer: "대체적으로 비동의",
        스위치: -38,
        바닐라: -2,
      },
      {
        answer: "비동의",
        스위치: -50,
        바닐라: -3,
      },
    ],
  },
  {
    index: 7,
    question:
      "나는 상대방의 명령을 듣고 상대방이 원하는 대로 움직일 때 성적으로 흥분된다.",
    score: [
      {
        answer: "동의",
        슬레이브: 7,
        디그레이디: 7,
        서브미시브: 50,
        바닐라: -5,
      },
      {
        answer: "대체적으로 동의",
        슬레이브: 4,
        디그레이디: 4,
        서브미시브: 38,
        바닐라: -3,
      },
      {
        answer: "약간 동의",
        슬레이브: 2,
        디그레이디: 2,
        서브미시브: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        디그레이더: -2,
        디그레이디: -1,
        서브미시브: -16,
        바닐라: -5,
      },
      {
        answer: "대체적으로 비동의",
        디그레이더: -4,
        디그레이디: -2,
        서브미시브: -38,
        바닐라: -3,
      },
      {
        answer: "비동의",
        디그레이더: -7,
        디그레이디: -3,
        서브미시브: -50,
        바닐라: -1,
      },
    ],
  },
  {
    index: 8,
    question:
      "나는 상대방이 시간을 들여 나를 예쁘게 묶고 구속할 때에 흥분된다.",
    score: [
      {
        answer: "동의",
        로프버니: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        로프버니: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        로프버니: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        로프버니: -16,
      },
      {
        answer: "대체적으로 비동의",
        로프버니: -38,
      },
      {
        answer: "비동의",
        로프버니: -50,
      },
    ],
  },
  {
    index: 9,
    question:
      "상대방이 나에게 성적인 낙서를 하거나 저속한 취급을 하여 나를 수치스럽게 하는 상황이 부끄럽지만 좋다.",
    score: [
      {
        answer: "동의",
        디그레이디: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        디그레이디: 38,
      },
      {
        answer: "약간 동의",
        디그레이디: 16,
      },
      {
        answer: "약간 비동의",
        디그레이디: -16,
      },
      {
        answer: "대체적으로 비동의",
        디그레이디: -38,
      },
      {
        answer: "비동의",
        디그레이디: -50,
      },
    ],
  },
  {
    index: 10,
    question:
      "나는 상대를 로프 등으로 어떻게 묶을지 상상하며 상대를 음란한 자세로 묶고싶다.",
    score: [
      {
        answer: "동의",
        리거: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        리거: 38,
      },
      {
        answer: "약간 동의",
        리거: 16,
      },
      {
        answer: "약간 비동의",
        리거: -16,
      },
      {
        answer: "대체적으로 비동의",
        리거: -38,
      },
      {
        answer: "비동의",
        리거: -50,
      },
    ],
  },
  {
    index: 11,
    question:
      "상대방이 나를 존경하고 자신의 모든것을 맡기고 절대적으로 순종이길 바라며, 그럴 자격을 얻기위해 끊임없이 노력하고 상대가 나로인해 더 나은 사람이 되었으면 한다.",
    score: [
      {
        answer: "동의",
        마스터: 45,
        서브미시브: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        마스터: 33,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        마스터: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        마스터: -16,
      },
      {
        answer: "대체적으로 비동의",
        마스터: -33,
      },
      {
        answer: "비동의",
        마스터: -45,
      },
    ],
  },
  {
    index: 12,
    question:
      "나는 상대방이 순종적이거나, 순종하지 않고 저항하거나 반항하는것에는 상관 없이 그저 상대방을 무력으로 제압하는 과정 자체를 즐긴다.",
    score: [
      {
        answer: "동의",
        헌터: 50,
      },
      {
        answer: "대체적으로 동의",
        헌터: 38,
      },
      {
        answer: "약간 동의",
        헌터: 16,
      },
      {
        answer: "약간 비동의",
        헌터: -16,
      },
      {
        answer: "대체적으로 비동의",
        헌터: -38,
      },
      {
        answer: "비동의",
        헌터: -50,
      },
    ],
  },
  {
    index: 13,
    question:
      "나는  상대와 나의 완전한 위치 차이에서 오는 무력감과 함께 어쩔 수 없이 성관계가 이루어지는 상황이 섹시하다.",
    score: [
      {
        answer: "동의",
        프레이: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        프레이: 38,
      },
      {
        answer: "약간 동의",
        프레이: 16,
      },
      {
        answer: "약간 비동의",
        프레이: -16,
      },
      {
        answer: "대체적으로 비동의",
        프레이: -38,
      },
      {
        answer: "비동의",
        프레이: -50,
      },
    ],
  },
  {
    index: 14,
    question:
      "상대방에게 야한 명령을 하거나 수치심을 느낄 수 있는 말과 행동을 좋아한다.",
    score: [
      {
        answer: "동의",
        디그레이더: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        디그레이더: 38,
      },
      {
        answer: "약간 동의",
        디그레이더: 16,
      },
      {
        answer: "약간 비동의",
        디그레이더: -16,
      },
      {
        answer: "대체적으로 비동의",
        디그레이더: -38,
      },
      {
        answer: "비동의",
        디그레이더: -50,
      },
    ],
  },
  {
    index: 15,
    question:
      "나는 상대를 어떻게 해야 신체에 부담이 가지 않고 더 예쁘게 묶을 수 있을지 고민한다.",
    score: [
      {
        answer: "동의",
        리거: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        리거: 38,
      },
      {
        answer: "약간 동의",
        리거: 16,
      },
      {
        answer: "약간 비동의",
        리거: -16,
      },
      {
        answer: "대체적으로 비동의",
        리거: -38,
      },
      {
        answer: "비동의",
        디그레이더: -50,
      },
    ],
  },
  {
    index: 16,
    question:
      "나는 내가 원하는 특정 연령대의 상대방이 있으며 그 상대에게 보살핌 받을 때 행복하다.",
    score: [
      {
        answer: "동의",
        리틀: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        리틀: 38,
      },
      {
        answer: "약간 동의",
        리틀: 16,
      },
      {
        answer: "약간 비동의",
        리틀: -16,
      },
      {
        answer: "대체적으로 비동의",
        리틀: -38,
      },
      {
        answer: "비동의",
        리틀: -50,
      },
    ],
  },
  {
    index: 17,
    question:
      "나는 상대방을 때리는 강도와 도구에 따른 차이를 알고 있으며, 상대의 반응이 중요하다.",
    score: [
      {
        answer: "동의",
        스팽커: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        스팽커: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        스팽커: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        스팽커: -16,
      },
      {
        answer: "대체적으로 비동의",
        스팽커: -38,
      },
      {
        answer: "비동의",
        스팽커: -50,
      },
    ],
  },
  {
    index: 18,
    question: "나는 상대를 순종적으로 만들 수 있는 나만의 방법이 있다.",
    score: [
      {
        answer: "동의",
        마스터: 3,
        오너: 3,
        대디: 3,
        디그레이더: 3,
        도미넌트: 40,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        마스터: 2,
        오너: 2,
        대디: 2,
        디그레이더: 2,
        도미넌트: 35,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        마스터: 1,
        오너: 1,
        대디: 1,
        디그레이더: 16,
        도미넌트: 35,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        도미넌트: -16,
      },
      {
        answer: "대체적으로 비동의",
        도미넌트: -38,
      },
      {
        answer: "비동의",
        도미넌트: -50,
      },
    ],
  },
  {
    index: 19,
    question:
      "나는 관계 중 혹은 관계 후 투정부리고 징징대는 상대가 사랑스럽고 귀엽다.",
    score: [
      {
        answer: "동의",
        마스터: -5,
        슬레이브: -5,
        프레이: -5,
        대디: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -3,
      },
      {
        answer: "대체적으로 동의",
        마스터: -4,
        슬레이브: -4,
        프레이: -4,
        대디: 38,
        바닐라: -2,
      },
      {
        answer: "약간 동의",
        마스터: -3,
        슬레이브: -3,
        프레이: -3,
        대디: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        대디: -16,
      },
      {
        answer: "대체적으로 비동의",
        대디: -38,
      },
      {
        answer: "비동의",
        대디: -50,
      },
    ],
  },
  {
    index: 20,
    question:
      "상대에게 순순히 복종하지 않고 말썽을 부리며 상대가 화를 내는 모습을 원하며, 단순히 순종하는 것 보다 강제로 굴복당하는 상황이 짜릿하다고 생각한다.",
    score: [
      {
        answer: "동의",
        브랫: 50,
        도미넌트: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        브랫: 38,
      },
      {
        answer: "약간 동의",
        브랫: 16,
      },
      {
        answer: "약간 비동의",
        브랫: -16,
      },
      {
        answer: "대체적으로 비동의",
        브랫: -38,
      },
      {
        answer: "비동의",
        브랫: -50,
      },
    ],
  },
  {
    index: 21,
    question: "이 테스트에 나온 수많은 용어, 문장들이 나는 별로 흥미롭지 않다.",
    score: [
      {
        answer: "동의",
        바닐라: 50,
      },
      {
        answer: "대체적으로 동의",
        바닐라: 38,
      },
      {
        answer: "약간 동의",
        바닐라: 16,
      },
      {
        answer: "약간 비동의",
        바닐라: -16,
      },
      {
        answer: "대체적으로 비동의",
        바닐라: -38,
      },
      {
        answer: "비동의",
        바닐라: -50,
      },
    ],
  },
  {
    index: 22,
    question:
      "나는 상대가 더 나를 괴롭혀줬으면 하는 마음에서 장난을 치고 반항을 한다.",
    score: [
      {
        answer: "동의",
        브랫: 50,
        도미넌트: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        브랫: 38,
      },
      {
        answer: "약간 동의",
        브랫: 16,
      },
      {
        answer: "약간 비동의",
        브랫: -16,
      },
      {
        answer: "대체적으로 비동의",
        브랫: -38,
      },
      {
        answer: "비동의",
        브랫: -50,
      },
    ],
  },
  {
    index: 23,
    question:
      "나는 상대방에게 맞는것에 흥분하며 맞을 때 나는 소리와 고통에 쾌감을 얻는다.",
    score: [
      {
        answer: "동의",
        스팽키: 50,
      },
      {
        answer: "대체적으로 동의",
        스팽키: 38,
      },
      {
        answer: "약간 동의",
        스팽키: 16,
      },
      {
        answer: "약간 비동의",
        스팽키: -16,
      },
      {
        answer: "대체적으로 비동의",
        스팽키: -38,
      },
      {
        answer: "비동의",
        스팽키: -50,
      },
    ],
  },
  {
    index: 24,
    question:
      "나는 상대방에게 존경받기위해 노력하며, 상대의 정신과 육체를 완전히 지배하고 소유하고싶다.",
    score: [
      {
        answer: "동의",
        마스터: 50,
        브랫: 3,
        오너: 3,
        도미넌트: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        마스터: 38,
        브랫: 2,
        오너: 2,
      },
      {
        answer: "약간 동의",
        마스터: 16,
        브랫: 1,
        오너: 1,
      },
      {
        answer: "약간 비동의",
        마스터: -16,
        브랫: -1,
        오너: -1,
      },
      {
        answer: "대체적으로 비동의",
        마스터: -38,
        브랫: -2,
        오너: -2,
      },
      {
        answer: "비동의",
        마스터: -50,
        브랫: -3,
        오너: -3,
      },
    ],
  },
  {
    index: 25,
    question:
      "나는 상하관계 중 한가지 포지션만을 가지고 있는 상대가 매력적이지 않다.",
    score: [
      {
        answer: "동의",
        스위치: 45,
      },
      {
        answer: "대체적으로 동의",
        스위치: 35,
      },
      {
        answer: "약간 동의",
        스위치: 16,
      },
      {
        answer: "약간 비동의",
        스위치: -16,
      },
      {
        answer: "대체적으로 비동의",
        스위치: -35,
      },
      {
        answer: "비동의",
        스위치: -45,
      },
    ],
  },
  {
    index: 26,
    question:
      "나는 상대가 고통받는 모습을 보면서 흥분하고, 그러기 위해 많은 방법이나 도구를 선택한다.",
    score: [
      {
        answer: "동의",
        사디스트: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        사디스트: 38,
      },
      {
        answer: "약간 동의",
        사디스트: 16,
      },
      {
        answer: "약간 비동의",
        사디스트: -16,
      },
      {
        answer: "대체적으로 비동의",
        사디스트: -38,
      },
      {
        answer: "비동의",
        사디스트: -50,
      },
    ],
  },
  {
    index: 27,
    question:
      "육체적인 고통 뿐만 아니라, 정신적인 고통 또한 나를 흥분하게 만든다.",
    score: [
      {
        answer: "동의",
        마조히스트: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        마조히스트: 38,
      },
      {
        answer: "약간 동의",
        마조히스트: 16,
      },
      {
        answer: "약간 비동의",
        마조히스트: -16,
      },
      {
        answer: "대체적으로 비동의",
        마조히스트: -38,
      },
      {
        answer: "비동의",
        마조히스트: -50,
      },
    ],
  },
  {
    index: 28,
    question:
      "나에게 순종하는 파트너보다는 반항하고 저항하는 상대를 굴복시키고 싶다.",
    score: [
      {
        answer: "동의",
        브랫테이머: 50,
        로프버니: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        브랫테이머: 38,
      },
      {
        answer: "약간 동의",
        브랫테이머: 16,
      },
      {
        answer: "약간 비동의",
        브랫테이머: -16,
      },
      {
        answer: "대체적으로 비동의",
        브랫테이머: -38,
      },
      {
        answer: "비동의",
        브랫테이머: -50,
      },
    ],
  },
  {
    index: 29,
    question:
      "나는 존경하는 상대를 만나 나를 지배해주고 관리해주는 상대방에게 안정감을 느낀다.",
    score: [
      {
        answer: "동의",
        슬레이브: 50,
        펫: 3,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        슬레이브: 38,
        펫: 2,
      },
      {
        answer: "약간 동의",
        슬레이브: 16,
        펫: 2,
      },
      {
        answer: "약간 비동의",
        슬레이브: -16,
        펫: -1,
      },
      {
        answer: "대체적으로 비동의",
        슬레이브: -38,
        펫: -2,
      },
      {
        answer: "비동의",
        슬레이브: -50,
        펫: -3,
      },
    ],
  },
  {
    index: 30,
    question:
      "살살 까불며 화를 돋구는 상대를 보면서 어떻게 저 녀석을 혼쭐낼지 머릿속으로 상상하면 즐겁다.",
    score: [
      {
        answer: "동의",
        브랫테이머: 50,
        도미넌트: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        브랫테이머: 38,
      },
      {
        answer: "약간 동의",
        브랫테이머: 16,
      },
      {
        answer: "약간 비동의",
        브랫테이머: -16,
      },
      {
        answer: "대체적으로 비동의",
        브랫테이머: -38,
      },
      {
        answer: "비동의",
        브랫테이머: -50,
      },
    ],
  },
  {
    index: 31,
    question:
      "상대가 나에게 주는 가학은 곧 사랑이며, 고통을 주는 상대방이 섹시하다고 느낀다.",
    score: [
      {
        answer: "동의",
        마조히스트: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        마조히스트: 38,
      },
      {
        answer: "약간 동의",
        마조히스트: 16,
      },
      {
        answer: "약간 비동의",
        마조히스트: -16,
      },
      {
        answer: "대체적으로 비동의",
        마조히스트: -38,
      },
      {
        answer: "비동의",
        마조히스트: -50,
      },
    ],
  },
  {
    index: 32,
    question:
      "나는 존경하는 상대방을 만나고 싶으며 이 관계에 있어 상대가 하는 성적 명령을 포함한 모든 명령들은 절대적이며, 그것을 따르는데 거부감이 없다.",
    score: [
      {
        answer: "동의",
        슬레이브: 50,
        도미넌트: 1,
        바닐라: -1,
      },
      {
        answer: "대체적으로 동의",
        슬레이브: 38,
      },
      {
        answer: "약간 동의",
        슬레이브: 16,
      },
      {
        answer: "약간 비동의",
        슬레이브: -16,
      },
      {
        answer: "대체적으로 비동의",
        슬레이브: -38,
      },
      {
        answer: "비동의",
        슬레이브: -50,
      },
    ],
  },
  {
    index: 33,
    question:
      "나에게 있어 관계 중 상대방에게 명령을 내리는 행동은 자연스러운 것이다.",
    score: [
      {
        answer: "동의",
        마스터: 12,
        디그레이더: 12,
        도미넌트: 12,
      },
      {
        answer: "대체적으로 동의",
        마스터: 6,
        디그레이더: 6,
        도미넌트: 6,
      },
      {
        answer: "약간 동의",
        마스터: 3,
        디그레이더: 3,
        도미넌트: 3,
      },
      {
        answer: "약간 비동의",
      },
      {
        answer: "대체적으로 비동의",
      },
      {
        answer: "비동의",
      },
    ],
  },
  {
    index: 34,
    question:
      "내가 상대방에게 음담패설을 하거나 성적으로 저속한 호칭으로 부를 때, 상대가 이를 받아 들이는것이 흥분된다.",
    score: [
      {
        answer: "동의",
        프레이: 3,
        디그레이더: 50,
        서브미시브: 1,
        스위치: 1,
        바닐라: -5,
      },
      {
        answer: "대체적으로 동의",
        프레이: 2,
        디그레이더: 38,
        바닐라: -3,
      },
      {
        answer: "약간 동의",
        프레이: 1,
        디그레이더: 16,
        바닐라: -1,
      },
      {
        answer: "약간 비동의",
        디그레이더: -16,
      },
      {
        answer: "대체적으로 비동의",
        디그레이더: -38,
      },
      {
        answer: "비동의",
        디그레이더: -50,
      },
    ],
  },
  {
    index: 35,
    question: "나는 거칠게 반항하는 나를 상대방이 무참히 제압해주었으면 한다.",
    score: [
      {
        answer: "동의",
        프레이: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -5,
      },
      {
        answer: "대체적으로 동의",
        프레이: 38,
      },
      {
        answer: "약간 동의",
        프레이: 16,
      },
      {
        answer: "약간 비동의",
        프레이: -16,
      },
      {
        answer: "대체적으로 비동의",
        프레이: -38,
      },
      {
        answer: "비동의",
        프레이: -50,
      },
    ],
  },
  {
    index: 36,
    question:
      "나는 상대방이 나에게 반항하고 도망치려 할 때 무참하게 제압하고 싶다.",
    score: [
      {
        answer: "동의",
        헌터: 50,
        도미넌트: 1,
        스위치: 1,
        바닐라: -5,
      },
      {
        answer: "대체적으로 동의",
        헌터: 38,
      },
      {
        answer: "약간 동의",
        헌터: 16,
      },
      {
        answer: "약간 비동의",
        헌터: -16,
      },
      {
        answer: "대체적으로 비동의",
        헌터: -38,
      },
      {
        answer: "비동의",
        헌터: -50,
      },
    ],
  },
  {
    index: 37,
    question:
      "나는 때때로 상대방을 따끔하게 훈육하기도 하지만 그것은 사랑이다.",
    score: [
      {
        answer: "동의",
        오너: 47,
      },
      {
        answer: "대체적으로 동의",
        오너: 35,
      },
      {
        answer: "약간 동의",
        오너: 16,
      },
      {
        answer: "약간 비동의",
        오너: -16,
      },
      {
        answer: "대체적으로 비동의",
        오너: -38,
      },
      {
        answer: "비동의",
        오너: -50,
      },
    ],
  },
  {
    index: 38,
    question: "나는 상대방과 교감을 통해서 나에게 소속되도록 기들이고 싶다.",
    score: [
      {
        answer: "동의",
        오너: 47,
      },
      {
        answer: "대체적으로 동의",
        오너: 35,
      },
      {
        answer: "약간 동의",
        오너: 16,
      },
      {
        answer: "약간 비동의",
        오너: -16,
      },
      {
        answer: "대체적으로 비동의",
        오너: -38,
      },
      {
        answer: "비동의",
        오너: -50,
      },
    ],
  },
  {
    index: 39,
    question:
      "나는 내가 어떤 행동을 해야 상대가 기뻐하는지 눈치를 살피면서 끝없이 애정과 관심을 갈구한다.",
    score: [
      {
        answer: "동의",
        펫: 50,
      },
      {
        answer: "대체적으로 동의",
        펫: 38,
      },
      {
        answer: "약간 동의",
        펫: 16,
      },
      {
        answer: "약간 비동의",
        펫: -16,
      },
      {
        answer: "대체적으로 비동의",
        펫: -38,
      },
      {
        answer: "비동의",
        펫: -50,
      },
    ],
  },
  {
    index: 40,
    question:
      "나는 상대방이 나를 애완동물처럼 우쭈쭈 해줄 때 행복감을 느끼며, 상대에게 강하게 소속되고싶다.",
    score: [
      {
        answer: "동의",
        펫: 50,
      },
      {
        answer: "대체적으로 동의",
        펫: 38,
      },
      {
        answer: "약간 동의",
        펫: 16,
      },
      {
        answer: "약간 비동의",
        펫: -16,
      },
      {
        answer: "대체적으로 비동의",
        펫: -38,
      },
      {
        answer: "비동의",
        펫: -50,
      },
    ],
  },
  {
    index: 41,
    question:
      "나는 상대방을 부드럽게 보살피며, 이는 상대방에 대한 애정과 관심이므로, 상대가 나에게 의지하기를 원한다.",
    score: [
      {
        answer: "동의",
        대디: 50,
      },
      {
        answer: "대체적으로 동의",
        대디: 38,
      },
      {
        answer: "약간 동의",
        대디: 16,
      },
      {
        answer: "약간 비동의",
        대디: -16,
      },
      {
        answer: "대체적으로 비동의",
        대디: -38,
      },
      {
        answer: "비동의",
        대디: -50,
      },
    ],
  },
  {
    index: 42,
    question:
      "나는 상대에게 관심을 끌기 위해 투정부리며 떼를 쓰며, 나를 보살펴야하는 존재로 봐주길 바란다.",
    score: [
      {
        answer: "동의",
        리틀: 50,
      },
      {
        answer: "대체적으로 동의",
        리틀: 38,
      },
      {
        answer: "약간 동의",
        리틀: 16,
      },
      {
        answer: "약간 비동의",
        리틀: -16,
      },
      {
        answer: "대체적으로 비동의",
        리틀: -38,
      },
      {
        answer: "비동의",
        리틀: -50,
      },
    ],
  },
];
